import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'
import { selectAuthDetails } from 'store/slices/authSlice';

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const auth_details = useSelector(selectAuthDetails)

	if (!token) {
		return <Outlet />
	}

	const roleId = auth_details?.role_id
	const isAdmin = roleId === 1 || roleId === '1'
	const dashboardPath = isAdmin ? AUTHENTICATED_ENTRY : '/dashboards/employee-dashboard'

	return <Navigate to={dashboardPath} />
}

export default PublicRoute